// extracted by mini-css-extract-plugin
export default {"CounterOfferMessage":"styles_CounterOfferMessage__VgGr8"};